import { useQuery } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import FeedbackCard from 'Components/FeedbackCard/FeedbackCard';
import { TFeedback } from 'Components/FeedbackCard/FeedbackCard.helpers';
import PageView from 'common/PageView/PageView';
import config from 'config/config';
import { Heading1 } from 'uikit/Heading';
import { TextP1 } from 'uikit/Text';
import routes from 'utils/routeTranslator';

import { reviewsQuery, ReviewsQueryResponse } from './Reviews.helpers';
import './Reviews.scss';

const Reviews = () => {
  const { loading, data } = useQuery<ReviewsQueryResponse>(reviewsQuery);

  if (loading || !data) return null;

  const { reviewsQuery: reviews } = data;
  const siteTitle = t`Fixly Opinie - 135 Recenzji na temat Fixly.pl`;
  // eslint-disable-next-line max-len
  const siteDescription = t`Opinie serwisu Fixly zebrane w jednym miejscu. Sprawdź, jak użytkownicy oceniają wykonawców. Zobacz rekomendacje zadowolonych klientów.`;

  return (
    <div className="reviewsPage">
      <Helmet>
        <title>{siteTitle}</title>
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta name="description" content={siteDescription} />
        <link rel="canonical" href={config.SITE_URL + routes.get('front::reviews')} />
      </Helmet>
      <PageView pageLabel="reviews_page" />

      <header className="reviewsPage__header">
        <div className="reviewsPage__title">
          <Heading1>
            <Trans>Fixly - opinie użytkowników</Trans>
          </Heading1>
        </div>
        <TextP1>
          <Trans>Zobacz opinie, które użytkownicy Fixly wystawiają wykonawcom za zrealizowane prace.</Trans>
        </TextP1>
      </header>
      <div className="reviewsPage__feedbacks">
        {reviews.map((feedback: TFeedback) => (
          <div className="reviewsPage__feedback" key={feedback.id}>
            <FeedbackCard {...feedback} type="block" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
